import React from 'react';
import Collapsible from 'react-collapsible';
import { connect } from 'react-redux';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { userMenus } from './MenuItems';
import MenuNode from './MenuNode';

const SideMenuList = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'components.sideMenu' });
	const { user, company, isDevicesHaveProblems, lastViewedVehiclesPage, open, onItemClick } = props
	const userRole = user.roles[0]
	const userPermissions = user.permissions || []
	const user_company_permissions = user.company_data;
	const showZonesMenu = company.company_data?.geofencing_active

	let menuItems = {}
	if (['custom_user', 'custom_partner'].includes(userRole)) {
		const menu = [];
		const permissions = userPermissions
			.filter(e => e.perm_category_name !== 'Other' && e.a_view === true)
			.map(({ perm_category_id }) => perm_category_id)

		userMenus[userRole].menu.forEach((menuItem, index) => {
			switch (index + 1) {
				case 1:
					if (permissions.includes(1)) { // homepage
						menu.push(menuItem)
					}
					break;
				case 2:
					if (permissions.includes(2)) { // event
						menu.push(menuItem)
					}
					break;
				case 3:
					if (permissions.includes(3)) { // reports
						menu.push(menuItem)
					}
					break;
				case 4:
					if (permissions.includes(4) || permissions.includes(5) || permissions.includes(15)) { // managevehicles
						menu.push(menuItem)
					}
					break;
				case 5:
					if (permissions.includes(6)) { // managegroups
						menu.push(menuItem)
					}
					break;
				case 6:
					if (permissions.includes(11)) { // driver
						menu.push(menuItem)
					}
					break;
				case 7:
					if (permissions.includes(16)) { // manageusers
						menu.push(menuItem)
					}
					break;
				case 8:
					if (permissions.includes(17)) { // firmware
						menu.push(menuItem)
					}
					break;
				default:
					break;
			}
		})
		menuItems.menu = [...new Set(menu)]
	}
	else if (['fleet_manager'].includes(userRole)) {
		menuItems = userMenus[userRole]
	}
	else {
		menuItems = userMenus[userRole]
	}

	if (!user_company_permissions.storage_active && ['fleet_manager', 'fleet_maintainer', 'group_manager', 'user', 'partner_view'].includes(userRole)) {
		menuItems.menu = menuItems.menu.filter(page => page.linkTo !== '/event')
	}

	const bubbleShow = (menuItem) => {
		const { linkTo } = menuItem;

		if (location.pathname !== '/managevehicles' && linkTo === '/managevehicles') {
			const obj = lastViewedVehiclesPage.find(({ companyId }) => companyId === company.company_id)
			if (obj && moment.utc().diff(moment.utc(obj.ts, 'YYYYMMDDHHmmss'), 'minutes') < 30) {
				return false
			}

			return isDevicesHaveProblems
		}

		return false
	}

	const handleItemClick = (menuItem) => {
		onItemClick && onItemClick(menuItem)
	}

	return (
		<div className="sideMenu-nav">
			<ul className="sideMenu-list">
				{menuItems.menu.filter(menuItem => {
					const isZonesMenu = menuItem.linkTo === '/zones';
					return !isZonesMenu || (isZonesMenu && showZonesMenu);
				}).map((menuItem, index) =>
					<MenuNode
						linkIndex={index === 0}
						linkTo={menuItem.linkTo}
						key={menuItem.linkTitle}
						linkTitle={i18n.t(`constants.pages.title${menuItem.linkTitle.replace(" ", "")}`)}
						itemIcon={menuItem.itemIcon}
						open={open}
						onClick={() => handleItemClick(menuItem)}
						bubbleShow={bubbleShow(menuItem)}
						{...(menuItem.titleCaption && {
							titleCaption: i18n.t(`zonesPage.${menuItem.titleCaption}`)
						})}
					/>
				)}
				{menuItems.collapsible && (
					<ul className="sideMenu-list">
						<Collapsible
							trigger={<div className="menu-item">
								<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-gear" viewBox="0 0 16 16">
									<path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
									<path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
								</svg>
								<span className="text">{t('textFleet')}</span>
							</div>}
							className="collapsible"
							openedClassName="collapsible collapsible-open"
							triggerClassName="trigger"
							triggerOpenedClassName="trigger trigger-open"
							contentInnerClassName="collapsible-menu"
							open={false}
						>
							{menuItems.collapsible.map(menuItem =>
								<MenuNode
									key={menuItem.linkTitle}
									linkTo={menuItem.linkTo}
									linkTitle={i18n.t(`constants.pages.title${menuItem.linkTitle.replace(" ", "")}`)}
									itemIcon={menuItem.itemIcon}
									open={open}
									onClick={() => handleItemClick(menuItem)}
									bubbleShow={bubbleShow(menuItem)}
									{...(menuItem.titleCaption && {
										titleCaption: i18n.t(`zonesPage.${menuItem.titleCaption}`)
									})}
								/>
							)}
						</Collapsible>
					</ul>
				)}
			</ul>
		</div>
	)
}

const mapStateToProps = ({ user, company, assets }) => ({
	user: user.user,
	company: company.company,
	isDevicesHaveProblems: assets.isDevicesHaveProblems,
	lastViewedVehiclesPage: assets.lastViewedVehiclesPage,
})

export default connect(mapStateToProps)(SideMenuList);
